import apiClient from "@/config/api";
const  RESOURCE = "/users"



const actions = {
    getUsers({commit}) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        return new Promise((resolve, reject) => {
            apiClient.get(RESOURCE, config)
                .then(res => {
                    commit("SET_USERS", res.data);
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    changeUserStatus({commit}, userDate) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        return new Promise((resolve, reject) => {
            apiClient.put(`${RESOURCE}/status/${userDate.id}`, userDate, config)
                .then(res => {
                    commit("REQUEST_OK", res.data);
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    changeUserAdmin({commit}, userDate) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        return new Promise((resolve, reject) => {
            apiClient.put(`${RESOURCE}/makeadmin/${userDate.id}`, userDate, config)
                .then(res => {
                    commit("REQUEST_OK", res.data);
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    }
}

export default actions;